import { tv } from "tailwind-variants";

export const buttonVariants = tv({
  // The height is fixed, so a wrapped label would be cut off: widen instead.
  base: "font-inherit h-(--button-height) rounded-(--button-radius) px-(--button-padding-x) m-0 inline-flex select-none items-center justify-center whitespace-nowrap focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed",
  variants: {
    variant: {
      primary:
        "bg-(--button-primary-background) text-(--button-primary-foreground) hover:bg-(--button-primary-hover-background) hover:text-(--button-primary-hover-foreground) hover:border-(--button-primary-hover-border) active:bg-(--button-primary-active-background) active:text-(--button-primary-active-foreground) disabled:bg-(--button-primary-disabled-background) disabled:text-(--button-primary-disabled-foreground)",
      secondary:
        "border-(--button-secondary-border) bg-(--button-secondary-background) text-(--button-secondary-foreground) hover:bg-(--button-secondary-hover-background) hover:text-(--button-secondary-hover-foreground) hover:border-(--button-secondary-hover-border) active:bg-(--button-secondary-active-background) active:text-(--button-secondary-active-foreground) disabled:border-(--button-secondary-disabled-border) disabled:bg-(--button-secondary-disabled-background) disabled:text-(--button-secondary-disabled-foreground) border",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});
